/// <reference path="../libs.ts" />
import { IViewDetailInfo, IViewInfo } from '../models/IViewInfo';
import { IWorkbookBase, IWorkbookParentInfo } from '../models/IWorkbookInfo';
import { Module } from '../Module';
import { Views } from '../resources/Views';

export class Dashboards {

  public static $inject = [
    '$q',
    'Views'
  ];

  constructor(
    private $q: ng.IQService,
    private views: Views,
  ) {}

  public getDashboardsForWorkbook(workbook: IWorkbookBase | IWorkbookParentInfo) {
    const viewsQuery = this.views.forWorkbook(workbook);

    return viewsQuery.getCount()
    .then((viewCount) => viewsQuery.getSlice(0, viewCount))
    .then((viewsList) => {
      const allPromises = viewsList.items.map(view => this.returnViewIfDashboard(view));
      return this.$q.all(allPromises);
    })
    .then((viewsList) => {
      return viewsList.filter((view: IViewInfo) => { return view != undefined; });
    });
  }

  private returnViewIfDashboard(view: IViewInfo) : ng.IPromise<IViewInfo> {
    return this.views.getById(view.id).then((details: IViewDetailInfo): ng.IPromise<IViewInfo> => {
      if (details.sheetType === 'dashboard') {
        return this.$q.resolve(view);
      }
      return this.$q.resolve(undefined);
    });
  }
}

Module.instance().service('Dashboards', Dashboards);
